<template>
<div id='panel'>
  <div class='iconBox' @click='swapInfo'>
    <font-awesome-icon class='icon' icon='calendar-alt' />
  </div>
  <div class='vertical'></div>
  <div class='iconBox' @click='updatePlayState'>
    <font-awesome-icon id='playPause' class='icon' :icon='playStateWord' />
  </div>
  <div class='vertical'></div>
  <div class='timeDisplayBox'><label class='timeDisplay'>{{time}}</label></div>
  <div class='vertical leftMargin'></div>
  <div class='progressBar' @click="setTime">
    <div class='progressBarBack'>
      <div class='progressBarFront' :style='{width:100*playedRatio+"%"}'></div>
    </div>
  </div>
  <div class='vertical rightMargin'></div>
  <div class='timeDisplayBox'><label class='timeDisplay'>{{durationDisplay}}</label></div>
  <div class='vertical'></div>
  <div class='iconBox' @click='swapAmbisonicControl'>
    <font-awesome-icon class='icon' icon='compass' />
  </div>
  <div class='vertical'></div>
  <div class='iconBox' @click='swapVolumeControl'>
    <font-awesome-icon class='icon' icon='volume-up' />
  </div>

  <div id='ambisonicControl' v-show='showAmbisonicControl' :style="cssVars">
    <div class='headBox' :style="cssVars">
      <above :style="cssVars"></above>
    </div>
    <div class='vertical ambiControl'></div>
    <div class='headBox' :style="cssVars">
      <beside :style="cssVars"></beside>
    </div>
  </div>

  <div id='volumeControl' v-show='showVolumeControl' :style="cssVars">
    <input type='range' orient='vertical' draggable='false' ondragstart="return false;" min='0' max='1' step='0.01' v-model='amp' v-on:input='updateAmp'>
  </div>

  <info-panel v-show='showInfoPanel'></info-panel>
</div>
</template>
<script>
import Vue from 'vue';

const omnitone = require('./omnitone2.min.esm.js');
const Omnitone = omnitone.default;

// for omnitone
function crossProduct(a, b) {
  return [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0]
  ]
}
// for omnitone
function normalize(a) {
  var n = Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
  a[0] /= n;
  a[1] /= n;
  a[2] /= n;
  return a;
}

import {
  EventBus
} from '@/eventBus.js';
import Above from './AboveHead';
import Beside from './BesideHead';
import InfoPanel from './InfoPanel';
const AudioContext = window.AudioContext || window.webkitAudioContext;

export default {
  name: "AudioPlayer",
  data() {
    return {
      message: 'pre click',
      playState: 0,
      time: '0:00',
      duration: 0,
      durationDisplay: '0:00',
      playStateWord: 'play',
      playedRatio: 0,
      showAmbisonicControl: false,
      showVolumeControl: false,
      showInfoPanel: false,
      headBoxWidth: 180,
      matrix: new Float32Array(9),
      elevation: 0,
      azimuth: 0,
      amp: 0.5,
    }
  },
  components: {
    Above,
    Beside,
    InfoPanel
  },
  mounted() {
    this.Omnitone = Omnitone;
    this.EventBus = EventBus;
    this.ac = new AudioContext();
    this.sourceNode = this.ac.createBufferSource();
    this.masterGain = this.ac.createGain();
    this.masterGain.gain.setValueAtTime(this.amp, this.now());
    this.masterGain.connect(this.ac.destination);
    this.initOmnitone();

    EventBus.$on('marker', this.markerHandler);
    EventBus.$on('azimuth', this.updateAzimuth);
    EventBus.$on('elevation', this.updateElevation);
  },

  computed: {

    cssVars() {
      return {
        '--head-box-width': this.headBoxWidth + 'px',
      }
    }
  },

  methods: {

    updateAmp() {
      this.masterGain.gain.setValueAtTime(this.amp, this.now())
    },

    updateAzimuth(azimuth) {
      this.azimuth = azimuth;
      this.tumble();
    },

    updateElevation(elevation) {
      this.elevation = elevation;
      this.tumble();
    },

    tumble() {
      const theta = (this.azimuth / 180) * Math.PI;
      const phi = (this.elevation / 180) * Math.PI;
      const forward = [
        Math.sin(theta) * Math.cos(phi),
        Math.sin(phi),
        Math.cos(theta) * Math.cos(phi)
      ];
      const upInitial = [0, 1, 0];
      const right = normalize(crossProduct(forward, upInitial));
      const up = normalize(crossProduct(right, forward));

      Vue.set(this.matrix, 0, right[0]);
      Vue.set(this.matrix, 1, right[1]);
      Vue.set(this.matrix, 2, right[2]);
      Vue.set(this.matrix, 3, up[0]);
      Vue.set(this.matrix, 4, up[1]);
      Vue.set(this.matrix, 5, up[2]);
      Vue.set(this.matrix, 6, forward[0]);
      Vue.set(this.matrix, 7, forward[1]);
      Vue.set(this.matrix, 8, forward[2]);
      this.foaRenderer.setRotationMatrix3(this.matrix);
    },

    swapInfo() {
      this.showInfoPanel = this.showInfoPanel == true ? false : true;
    },

    swapAmbisonicControl() {
      this.showAmbisonicControl = this.showAmbisonicControl === true ? false : true;
    },

    swapVolumeControl() {
      this.showVolumeControl = this.showVolumeControl === true ? false : true;
    },

    // upon progressBar mouseup or click, update play position visually and in the audio element
    setTime(e) {
      const progressBar = document.querySelector('.progressBarBack');
      const width = progressBar.getBoundingClientRect().width;
      const currentTime = (e.offsetX / width) * this.audioElement.duration;
      this.audioElement.currentTime = Math.round(currentTime)

    },

    updateTime() {
      const secs = (Math.floor(this.audioElement.currentTime % 60) < 10 ? '0' : '') + Math.floor(this.audioElement.currentTime % 60);
      const mins = Math.floor(this.audioElement.currentTime / 60);
      this.time = mins + ":" + secs;
      this.duration = this.audioElement.duration;
      if (isNaN(this.duration)) {
        this.duration = 0;
      }
      // this is a little wasteful, but couldn't figure out when else to update duration
      const durSecs = (Math.floor(this.audioElement.duration % 60) < 10 ? '0' : '') + Math.floor(this.audioElement.duration % 60);
      const durMins = Math.floor(this.audioElement.duration / 60);
      this.durationDisplay = durMins + ":" + durSecs;
      this.playedRatio = this.audioElement.currentTime / this.audioElement.duration;

    },

    initOmnitone() {
      this.foaRenderer = Omnitone.createFOARenderer(this.ac);
      this.foaRenderer.initialize()
      this.foaRenderer.output.connect(this.masterGain);
      this.foaRenderer.setRenderingMode('ambisonic');
    },

    updatePlayState() {
      if (this.audioElement) {
        this.tumble();
        this.playState === 0 ? this.audioElement.play() : this.audioElement.pause();
        this.playState = Math.abs(this.playState - 1);
        this.playStateWord = ['play', 'pause'][this.playState];
      }
    },

    now() {
      return this.ac.currentTime
    },

    loadRecording(catNum) {
      catNum = catNum.toString();
      if (catNum.length != 3) {
        catNum = catNum.length === 2 ? '0' + catNum : '00' + catNum
      }

      if (this.mediaSource) {
        this.mediaSource.mediaElement.pause();
        this.mediaSource.disconnect();
      }
      const audioElement = document.createElement('audio');
      audioElement.setAttribute("crossorigin", "anonymous");
      audioElement.setAttribute("type", "audio/mpeg");
      audioElement.setAttribute("src", 'https://sonicmap.nyc3.digitaloceanspaces.com/UCSC/edited_catalog/' + catNum.toString() + '.wav')
      audioElement.setAttribute("id", catNum);
      if (this.ac.state === 'suspended') {
        this.ac.resume();
        this.tumble();
      }
      this.mediaSource = this.ac.createMediaElementSource(audioElement);
      this.mediaSource.connect(this.foaRenderer.input);
      this.playState = 0;
      this.playStateWord = 'play';
      this.durationDisplay = '0:00';
      return audioElement;
    },

    markerHandler(marker) {
      this.audioElement = this.loadRecording(marker.position.catNum);
      this.audioElement.ontimeupdate = () => {
        this.updateTime();
      };
      this.playedRatio = 0;
    },
  }
}
</script>

<style scoped>
#panel {
  z-index: 2;
  position: absolute;
  bottom: 0px;
  margin: 0;
  height: 40px;
  width: 100vw;
  background-color: lightgrey;
  border-top: 1px solid black;
}

#ambisonicControl {
  z-index: 1;
  width: calc(2 * var(--head-box-width) + 1);
  height: var(--head-box-width);
  top: calc(-2px + (var(--head-box-width) * -1));
  right: 40px;
  background-color: lightgrey;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid black;
  border-top: 1px solid black;
  border-right: 1px solid black;
}

#volumeControl {
  z-index: 0;
  width: 40px;
  height: var(--head-box-width);
  top: calc(-2px + (var(--head-box-width) * -1));
  right: 0px;
  background-color: lightgrey;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid black;
  border-left: 1px solid black;
}

input {
  height: 90%;
  width: 20px;
  writing-mode: bt-lr;
  /* IE */
  -webkit-appearance: slider-vertical;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

input:focus {
  outline: none;
}

.leftMargin {
  margin-right: 10px;
}

.rightMargin {
  margin-left: 10px;
}

.iconBox {
  width: 40px;
  height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.iconBox:hover .icon {
  color: darkGreen;
}

.timeDisplayBox {
  width: 50px;
  height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.timeDisplay {
  display: flex;
  align-items: center;
}

.progressBar {
  height: 100%;
  width: calc(100% - 292px);
  float: left;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  /* align-items: center; */
}
 
.progressBarBack {
  position: absolute;
  border-style: inset;
  z-index: 3;
  height: 40%;
  width: 100%;
  background-color: black;
  /* border-radius: 8px; */
  border-width: 1px;
  clip-path: inset(0 0 0 0 round 20px  )
}

.progressBarFront {
  /* position: absolute; */
  z-index: 4;
  height: 100%;
  width: 0%;
  background-color: royalblue;
  /* border-radius: 8p/x; */
  border-style: inset;
  border-right: 0px;
  border-left: 1px;
  border-top: 1px;
  border-bottom: 1px;
}

.vertical {
  float: left;
  height: 60%;
  position: relative;
  top: 20%;
  border-style: inset;
  border-width: 1px;
}

.ambiControl {
  top: 0px;
  height: 80%;
}

.headBox {
  width: var(--head-box-width);
  height: var(--head-box-width);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
